
import React from "react";
import schwab_email from "./schwab_email.png";

const EAST_DATA = {
  location: "East Coast",
  regular_mail: [
    "Charles Schwab & Co., INC",
    "P.O. Box 2380",
    "Omaha, NE 68103",
  ],
  overnight_mail: [
    "Charles Schwab & Co., INC",
    "200 S 108th Ave",
    "Omaha, NE 68154"
  ],
}

const WEST_DATA = {
  location: "West Coast",
  regular_mail: [
    "Charles Schwab & Co., INC",
    "P.O. Box 982603",
    "El Paso, Texas 79998",
  ],
  overnight_mail: [
    "Charles Schwab & Co., INC",
    "1945 Northwestern Drive",
    "El Paso, Texas 79912",
  ]
}

const dump_mail = (data) => {
  const bold_style = {
    fontWeight: "bold",
  }
  return (
    <div>
      <div style={bold_style}>{data.location}</div>
      <div style={{height: "1rem"}}/>
      <div style={bold_style}>Regular Mail</div>
      {data.regular_mail.map((line, index) => (<div key={index}>{line}</div>))}
      <div style={{height: "1rem"}}/>
      <div style={bold_style}>Overnight Mail</div>
      {data.overnight_mail.map((line, index) => (<div key={index}>{line}</div>))}
    </div>
  )
}
const SchwabMailInstructions = props => {
  const account_number = props.account_number;
  const img_style = {
    margin: "auto",
    display: "block",
    width: "30rem",
  }
  const ul_style = {
    listStyleType: "circle",
  }
  const global_style = {
    fontSize: "1.2rem",
  }
  return (
    <div style={global_style}>
      <ul style={ul_style}>
        <li>Make checks payable to YOU and your Schwab account number {account_number}.</li>
        <li>Properly endorsed by YOU on the back of the check with Your Signature and please write the following: Your
          name and your Schwab account number {account_number}</li>
      </ul>
      <div>
        <img alt={"email"} src={schwab_email} style={img_style}/>
      </div>
      <ul style={ul_style}>
        <li>For an IRA contribution indicate the tax year in the Memo Section of the check.</li>
        <li>Mail the check to the operations center closest to you (regular mail should be fine unless you would like to
          put the funds to work ASAP):
        </li>
      </ul>
      <div style={{height: "1rem"}}/>
      <div style={{display: "flex"}}>
        {dump_mail(EAST_DATA)}
        <div style={{width: "5rem"}}/>
        {dump_mail(WEST_DATA)}
      </div>
    </div>
  )
}

export {SchwabMailInstructions};
